import { render } from "./HeaderThorondor.vue?vue&type=template&id=7b05eb70"
import script from "./HeaderThorondor.vue?vue&type=script&lang=js"
export * from "./HeaderThorondor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__